import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenSession } from '../../models/users.interface';
import {
    debounceTime,
    distinctUntilChanged,
    Subject,
    takeUntil,
    tap,
} from 'rxjs';
import { LayoutService } from '../../services/layout/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/login/auth.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-search',
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
    ],
    templateUrl: './search.component.html',
    styleUrl: './search.component.css',
})
export class SearchComponent {
    search = '';
    showSearch = true;
    userSession: TokenSession | null = null;
    @Input() placeholder: string = 'Buscar...';
    protected _onDestroy = new Subject<void>();
    isLoadingInput = false;

    constructor(
        private layoutService: LayoutService,
        private authService: AuthService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router
    ) {}

    searchForm = this.fb.group({
        search: ['code'],
    });

    ngOnInit(): void {
        this.route.queryParamMap.subscribe((params) => {
            const search = params.get('search');
            if (search) {
                this.search = search;
                this.layoutService.setSearch(search);
                this.searchForm.get('search')?.setValue(search);
            }
        });
        this.searchForm
            .get('search')
            ?.valueChanges.pipe(
                tap(() => {
                    this.isLoadingInput = true;
                }),
                debounceTime(1500),
                tap(() => {
                    this.isLoadingInput = false;
                }),
                distinctUntilChanged(),
                takeUntil(this._onDestroy)
            )
            .subscribe((value) => {
                this.layoutService.setSearch(value);
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { search: value || null },
                    queryParamsHandling: 'merge',
                });
            });

        this.layoutService.showSearch$.subscribe(
            (show) => (this.showSearch = show)
        );
        this.authService.token$.subscribe(
            (token) => (this.userSession = token)
        );
        this.layoutService.search$.subscribe((keywords) => {
            if (keywords !== null && keywords !== undefined) {
                this.search = keywords;
            }
        });
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
